// Image preview controller
// Listens for file selection on a sibling file input (matched by name)
// and shows a client-side preview of the selected image before upload.
//
// Targets:
//   container - wrapper element (hidden until a file is selected)
//   image     - the <img> element where the preview is rendered
//
// Values:
//   inputName - the `name` attribute of the file input to observe

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "image"]
  static values = {
    inputName: String,
  }

  connect() {
    this._onFileChange = this._onFileChange.bind(this)

    const input = this._findInput()
    if (input) {
      input.addEventListener("change", this._onFileChange)
    }
  }

  disconnect() {
    const input = this._findInput()
    if (input) {
      input.removeEventListener("change", this._onFileChange)
    }
  }

  // Private

  _findInput() {
    const form = this.element.closest("form")
    if (!form) return null
    return form.querySelector(
      `input[type="file"][name="${this.inputNameValue}"]`,
    )
  }

  _onFileChange(event) {
    const file = event.target.files?.[0]
    if (!file || !file.type.startsWith("image/")) {
      this.containerTarget.style.display = "none"
      return
    }

    const reader = new FileReader()
    reader.onload = (e) => {
      this.imageTarget.src = e.target.result
      this.containerTarget.style.display = ""
    }
    reader.readAsDataURL(file)
  }
}
